export default __webpack_public_path__ + "static/media/coinmarketcap-logo.abfaf9eb.svg";